<template>
    <div v-if="cargando">
        <div class="row">
            <div class="col-md-12 text-center">
                <h3>Cargando <i class="fa fa-spin fa-spinner"></i></h3>
            </div>
        </div>
    </div>
    <div v-else>
    <br>
    <b-container fluid>
    <b-row>
        <b-col md="2">
            <b-form-group horizontal label="Orden" class="mb-0">
                <b-input-group>
                <b-form-select v-model="orden" slot="append" @input="listCreditNote">
                    <option :value="'asc'">Mas Antiguo</option>
                    <option :value="'desc'">Mas Reciente</option>
                </b-form-select>
                </b-input-group>
            </b-form-group>
        </b-col>
        <b-col cols="1" sm="2"	md="2"	lg="2"	xl="4">
              <b-form inline>
                  Desde: <b-input type="date" v-model="f1"/>
                  Hasta: <b-input type="date" v-model="f2"/>
              </b-form>
         </b-col>
        <b-col>
          <b-button @click="listCreditNote" variant="success">Buscar</b-button>
        </b-col>
        <b-col md="2">
            <div class="col-md-12 text-center">
                <b-button variant="secondary" @click="listCreditNote"><i class="fa fa-sync-alt"></i> </b-button>
            </div>
        </b-col>
        <b-col md="2">
            <b-form-group horizontal label="Mostrar" class="mb-0">
                <b-input-group>
                    <b-form-select v-model="limite" slot="append" @input="listCreditNote">
                    <option :value="10">10</option>
                        <option :value="25">25</option>
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                    </b-form-select>
                </b-input-group>
            </b-form-group>
        </b-col>
    </b-row>
    <br>
    <b-table
        responsive 
        :small="small"
        :outlined="outlined"
        :striped="striped"
        :items="creditnotes"
        :fields="creditnotes_fields"
        :current-page="pactual"
        :per-page="limite"            
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection" 
        >
        <template slot="estado" slot-scope="row">
            <template v-if="row.item.emitido==1 && row.item.baja==1">
                <div><span class="badge badge-dark">Baja <i class="fa fa-ban"></i></span></div>
            </template>
            <template v-else-if="row.item.emitido==3 && row.item.baja==0">
                <div><span class="badge badge-info">Baja pendiente <i class="fa fa-ban"></i></span></div>
            </template>
            <template v-else-if="row.item.emitido==3 && row.item.baja==0">
                <div><span class="badge badge-info">Baja pendiente <i class="fa fa-ban"></i></span></div>
            </template>
            <template v-else>
                <div v-if="row.item.emitido==1"><span class="badge badge-success">Emitido <i class="fa fa-check"></i></span></div>
                <div v-else-if="row.item.emitido==0"><span class="badge badge-warning" title="Las boletas se evian al final del día">Por Enviar <i class="fa fa-hourglass-half"></i></span></div>
                <div v-else-if="row.item.emitido==2"><span class="badge badge-danger">Rechazado <i class="fa fa-times"></i></span></div>
            </template>
        </template>
        <template slot="receptor" slot-scope="row">
            <template v-if="row.item.receiver">
                {{row.item.idReceptor}} - {{row.item.receiver.razonSocial}}
            </template>
            <template v-else>
                {{ row.item.idReceptor }}
            </template>
        </template>
        <template slot="emision" slot-scope="row">
            {{ row.item.fechaEmision | moment('D/M/Y hh:mm:ss A') }}
        </template>
        <template slot="moneda" slot-scope="row">
            <template v-if="row.item.tipoMoneda=='PEN'">S/</template>
            <template v-else-if="row.item.tipoMoneda=='USD'">$</template>
            <template v-else>{{ row.item.tipoMoneda }}</template>
            {{row.item.importeTotal}}
        </template>
        <template slot="acciones" slot-scope="row">
            <template v-if="row.item.emitido!=2 && row.item.baja!=1">
                <b-button-group>
                    <button v-show="!row.item.loading" type="button" class="btn" size="sm" @click="mostrarDetalles(row, row.index)" title="Mas opciones">
                        <template v-if="!row.item.mostrardetalles">
                            <i class="fa fa-plus"></i>
                        </template>
                        <template v-else>
                            <i class="fa fa-minus"></i>
                        </template>
                    </button>
                    <b-button size="sm" v-show="row.item.loading" variant="ligth"><i class="fa fa-spin fa-spinner"></i></b-button>
                    <b-button v-b-modal.modal4 v-b-tooltip.hover @click="viewPdf(row.item)"><i title="Vista Previa" class="fa fa-tv"></i></b-button>
                    <b-button @click="downloadPdf(row.item)" v-b-tooltip.hover><i  title="Descargar PDF" class="fa fa-file-pdf"></i></b-button>
                    <b-button @click="setTicket(row.item)" v-b-modal.modal1 v-b-tooltip.hover><i title="Enviar por Mail" class="fa fa-envelope"></i></b-button>                      
                    <b-button v-if="row.item.emitido==0" class="disabled" :disabled="true"><i title="Descargar CDR" class="fa fa-file-archive"></i></b-button>
                    <b-button v-else @click="downloadCdr(row.item)"><i title="Descargar CDR" class="fa fa-file-archive"></i></b-button>
                    <b-button v-if="row.item.emitido==0" class="disabled" :disabled="true" v-b-tooltip.hover><i title="Descargar XML" class="fa fa-file-code"></i></b-button>
                    <b-button v-else @click="downloadXml(row.item)" v-b-tooltip.hover><i title="Descargar XML" class="fa fa-file-code"></i></b-button>
                    <b-button v-if="row.item.emitido==0 || row.item.baja==1" v-show="row.item.emitido!=3 || row.item.baja==1" :disabled="true" v-b-tooltip.hover class="disabled btn btn-danger"><i title="Baja de Factura" class="fa fa-trash-alt text-white"></i></b-button>
                    <b-button v-else v-show="row.item.emitido!=3 || row.item.baja==1" @click="preBaja(row.item)" v-b-tooltip.hover class="btn btn-danger"><i title="Baja de Factura" class="fa fa-trash-alt text-white"></i></b-button> 
                </b-button-group>
            </template>
            <template v-else>
                <b-button-group>
                    <b-button @click="downloadCdr(row.item)"><i title="Descargar CDR" class="fa fa-file-archive"></i></b-button>
                    <b-button v-if="row.item.emitido==2" @click="estadoEmision(row.item)" v-b-modal.motivorechazo5 v-b-tooltip.hover variant="primary"><i title="Estado de la emision" class="fa fa-eye text-white"></i></b-button>
                </b-button-group>
            </template>
        </template>
        <template slot="row-details" slot-scope="row">
            <b-card class="tamanioletra">
                <b-table striped hover :items="row.item.lista" :fields="listaitems_fields" :busy="row.item.loading">
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Cargando...</strong>
                    </div>
                    <template slot="index" slot-scope="row">
                        {{ row.index+1 }}
                    </template>
                    <template slot="cantidad" slot-scope="row">
                        <div class="text-right">
                            {{ Number.parseFloat(row.item.cantidad).toFixed(2) }}
                        </div>
                    </template>
                    <template slot="precioVentaUnitario" slot-scope="row">
                        <div class="text-right">
                            <template v-if="row.item.moneda=='PEN'">S/</template>
                            <template v-else-if="row.item.moneda=='USD'">$</template>
                            <template v-else>{{ row.item.moneda }}</template>
                            <template v-if="row.item.precioVentaUnitario">
                                {{ Number.parseFloat(row.item.precioVentaUnitario).toFixed(2) }}
                            </template>
                        </div>
                    </template>
                    <template slot="descuento" slot-scope="row">
                        <div class="text-right">
                            <template v-if="row.item.moneda=='PEN'">S/</template>
                            <template v-else-if="row.item.moneda=='USD'">$</template>
                            <template v-else>{{ row.item.moneda }}</template>
                            <template v-if="row.item.descuento">
                                {{ Number.parseFloat(row.item.descuento).toFixed(2) }}
                            </template>
                            <template v-else>
                                0.00
                            </template>
                        </div>
                    </template>     
                    <template slot="valorVenta" slot-scope="row">
                        <div class="text-right">
                            <template v-if="row.item.moneda=='PEN'">S/</template>
                            <template v-else-if="row.item.moneda=='USD'">$</template>
                            <template v-else>{{ row.item.moneda }}</template>
                            <template v-if="row.item.valorVenta">
                                {{ Number.parseFloat(row.item.valorVenta*($store.state.igv == 18 ? 1.18 : 1.105)).toFixed(2) }} <!-- porque esta harcodeado el ivg 18% ?-->
                            </template>
                        </div>
                    </template>
                </b-table>
            </b-card>
        </template>
    </b-table>
    </b-container>
    <b-modal id="modal1" title="Enviar por Correo" v-model="previacorreo">
        <div role="group">
        <label for="inputLive">Correos:</label>
        <b-form-input v-model="recipients" type="email" @keyup.enter="sendMail(creditnote)"></b-form-input>
        <p class="input-requerido">Ingresa un correo ó varios separados por comas (,)</p>
        </div>
            <div slot="modal-footer" class="w-100">
            <b-btn v-if="!sendcorreo" size="sm" class="float-right" variant="primary" @click="sendMail(creditnote)">
            Enviar
            </b-btn>
            <b-btn v-else size="sm" class="float-right" variant="secondary">
            <i class="fa fa-spin fa-spinner"></i> Enviando...
            </b-btn>
        </div>
    </b-modal>
    <b-modal id="motivorechazo5" title="Motivo del Rechazo" v-model="motivoRechazo">
        <div role="group">
            <div v-if="spinoff">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <h3>Cargando <i class="fa fa-spin fa-spinner"></i></h3>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="row">
                    <div class="col-md-12 text-center">
                        <h6>{{ descripcionRechazo }}</h6>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100">
            <b-btn v-if="!sendcorreo" size="sm" class="float-right" variant="primary" @click="motivoRechazo=!motivoRechazo">
                Ok
            </b-btn>
        </div>
    </b-modal>
    <b-modal id="modal4" size="lg" title="Vista Previa" cancel-title="Cerrar" v-model="previanotacredito">
        <template v-if="cargandopdf2"><div class="text-center"><h3><i class="fa fa-spin fa-spinner"></i></h3> Cargando vista previa</div></template>
        <template v-else>
            <template v-if="pdfobject !==''">
            <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen></b-embed>
            </template>
        </template>
    </b-modal>
    <div class="row">
        <div class="col-md-9">
            <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
        </div>
        <div class="col-md-3">
            <b-pagination size="sm" :total-rows="paginaMaxima * limite" v-model="currentPage" :per-page="limite" @input="listCreditNote"></b-pagination>
        </div>
    </div>
    <vue-snotify></vue-snotify>
    <b-modal id="modalpreproccess" v-model="modal">
        <template slot="modal-title">
            <i class="fa fa-exclamation-triangle text-danger"></i> Dar de baja a una Nota de Credito
        </template>
        <p class="my-4 h4"><b>{{this.$store.getters.userData.username}}</b>, realmente desea dar de baja a la siguiente Nota de Credito?</p>
        <b-list-group>
            <template>
                <template>
                    <b-list-group-item>{{boletaItemBaja.serie + '-' + boletaItemBaja.numero + ' | ' + boletaItemBaja.idReceptor + '-' + boletaItemBaja.razonSocial}}</b-list-group-item>
                </template>
            </template>
        </b-list-group>
        <br>
        <b-alert v-if="!loading2" variant="danger" show>El siguiente procedimiento no se puede deshacer.</b-alert>
        <b-alert v-else variant="danger" show>Estamos dando de baja los documentos indicados.</b-alert>
        <template slot="modal-footer">
            <template v-if="!loading2">
            <b-button variant="secondary" @click="modal=false">No</b-button>
            <b-button variant="danger" @click="sendBaja"><i class="fa fa-cog"></i> Procesar</b-button>
            </template>
            <b-button v-else disabled variant="danger"><i class="fa fa-spin fa-cog"></i> Procesando</b-button>
        </template>
    </b-modal>
</div>
</template>

<script>
const config = {
       headers: {
            'Content-type': 'application/json; charset=utf-8',
            'Access-Control-Allow-Origin':'*',
            'Access-Control-Allow-Methods': 'POST',
            'Access-Control-Allow-Headers':'*',
            'cache-control': 'no-cache'
          }
}
import { tiposNotaCreditoB } from '@/shared/utils'
import download from 'downloadjs'
import axios from 'axios'
import Datepicker from 'vuejs-datepicker'
import {es} from 'vuejs-datepicker/dist/locale'
export default {
    name: 'NotaCreditoBoletaConsulta',
    components: {
        Datepicker
    },
    data: () => {
        return {
            modal: false,
            loading2: false,
            boletaItemBaja: {
                serie: '',
                numero: '',
                idReceptor: '',
                razonSocial: ''
            },
            boletaBaja: {
                serie: '',
                numero: ''
            },
            motivoRechazo: false,
            spinoff: false,
            descripcionRechazo: '',
            sortDirection: 'asc',
            outlined: true,
            striped: true,
            small: true,
            filter: null,
            sortBy: null,
            sortDesc: false,
            es: es,
            currentdate: '',
            currentPage: 1,
            femision: '',
            hemision: '',
            emisioncreditnote: false,
            previanotacredito: false,
            previacorreo: false,
            sendcorreo: false,
            total: 0.00,
            desde: 0.00,
            hasta: 0.00,
            paginaActual: 1, // Página actual seleccionada
            paginaMaxima: 2, // Estimación inicial del número de páginas
            haySiguientePagina: true, // Saber si existe una página siguiente
            cargando: false,
            pactual: 1,
            limite: 10,
            orden: 'desc',
            recipients: '',
            creditnotes: [],
            creditnotesticket: [],
            creditnotes_fields: [
                {key: 'serie', label: 'Serie', sortable: true},
                {key: 'numero', label: 'Numero', sortable: true},
                {key: 'emision', label: 'Emision', sortable: true},
                {key: 'receptor', label: 'Receptor', sortable: true},
                {key: 'moneda', label: 'Importe Total', sortable: true},
                {key: 'estado', label: 'Estado', sortable: true},
                {key: 'acciones', label: 'Acciones'}
            ],
            listaitems_fields: [
                {key: 'index'},
                {key: 'codigoProducto', label: 'Codigo', sorteable: true},
                {key: 'unidadMedidaCantidad', label: 'Unidad', sorteable: true},
                {key: 'descripcion', label: 'Descripción', sorteable: true},
                {key: 'cantidad', label: 'Cantidad', sorteable: true},
                {key: 'precioVentaUnitario', label: 'Precio Unit', sorteable: true},
                {key: 'descuento', label: 'Descuento', sorteable: true},
                {key: 'valorVenta', label: 'Precio Total', sorteable: true},
            ],
            creditnote: {},
            ticket: {},
            CreditNote: {
                token: '',
                serie: '',
                tipoNotaCredito: '',
                montoTotalImpuestos: '',
                totalVentaGravada: '',
                sumatoriaIgv: '',
                importeTotal: '',
                descripcion: '',
                tipoMoneda: '',
                serieAfectado: '',
                numeroAfectado: '',
                tipoComprobanteAfectado: '03',
                adicional: {
                    fechaVencimiento: "2018-12-25",
                    codigoSunatEstablecimiento: "0001"
                },
                items: [],
                receptor: {
                    tipo: '6',
                    nro: ''
                }
            },
            items: [],
            tiposNotaCredito: tiposNotaCreditoB,
            pdfobject: '',
            cargandopdf: false,
            cargandopdf2: false,
            f1:'',
            f2:'',
        }
    },
    mounted () {
        this.listCreditNote()
    },
    methods: {
        mostrarDetalles: function (row, index) {
            if(row.detailsShowing){
                row.toggleDetails()
                this.creditnotesticket[index].mostrardetalles = false
            }else{
                this.creditnotesticket[index].mostrardetalles = true
                this.creditnotesticket[index].loading = true
                if(this.creditnotesticket[index].lista.length == 0){
                    setTimeout(() => 
                        this.detallesDocumento(row, index)
                    , 10);  
                }else{
                    this.creditnotesticket[index].loading = false
                    row.toggleDetails()
                } 
            }
        },
        detallesDocumento: function (row, index) {
            axios
            .post(process.env.VUE_APP_API_URL + 'notacredito/items',{
                token: this.$store.getters.userToken,
                idcredit: row.item.idNotaCredito
            })
            .then(response => (
                this.parseDetallesDocumento(response.data.response, row, index)
            ))
            .catch(error => (  
                this.creditnotesticket[index].mostrardetalles = false
            )) 
        },
        parseDetallesDocumento: function (value, row, index) {
            this.creditnotesticket[index].lista = []
            for (let i=0; i<value.length; i++){
                value[i].moneda = row.item.tipoMoneda
                this.creditnotesticket[index].lista.push(value[i])
            }
            this.creditnotesticket[index].loading = false
            // this.creditnotesticket[index].mostrardetalles = false
            if(value.length > 0){
                row.toggleDetails()
            }
        },
        preBaja: function (value) {
            this.modal = true,
            this.boletaItemBaja.serie = value.serie,
            this.boletaItemBaja.numero = value.numero,
            this.boletaItemBaja.idReceptor = value.idReceptor,
            this.boletaItemBaja.razonSocial = value.receiver.razonSocial,
            this.boletaBaja.serie = value.serie,
            this.boletaBaja.numero = value.numero
        },
        sendBaja: function () {
            this.loading2 = true
            axios
            .post(process.env.VUE_APP_API_URL + 'comunicacionbaja/emitir/ncboleta', {
                token: this.$store.getters.userToken,
                serie: this.boletaBaja.serie,
                numero: this.boletaBaja.numero
            })
            .then(response => ( 
                this.loading2 = false,               
                this.modal = false,
                this.listCreditNote(),
                this.initValuesBaja(),
                this.$snotify.success(response.data.msg, 'Éxito')
            ))
            .catch((error) => (
                this.loading2 = false,
                this.modal = false,
                this.initValuesBaja(),
                this.$snotify.error(error.response.data.response.description, 'Error')
            )) 
        },
        initValuesBaja: function() {
            this.boletaItemBaja.serie = '',
            this.boletaItemBaja.numero = '',
            this.boletaItemBaja.idReceptor = '',
            this.boletaItemBaja.razonSocial = '',
            this.boletaBaja.serie = '',
            this.boletaBaja.numero = ''
        },
        setTicket: function (data) {
            this.creditnote = data
        },
        listCreditNote: function () {
            let dia1;
            let dia2;
            if(this.f1 === "" && this.f2 ===""){
                dia1 =  ""
                dia2 = ""
            }else{
                dia1 = this.$moment(this.f1).format('YYYY-MM-DD HH:mm:ss')
                dia2 = this.$moment(this.f2).format('YYYY-MM-DD 23:59:59')          
            }
            this.creditnotes = []
            this.cargando = true
            axios
            .post(process.env.VUE_APP_API_URL + 'notacredito/boleta', {
                token: this.$store.getters.userToken,
                f1:dia1,
                f2:dia2,
                page: this.currentPage,
                limit: this.limite,
                // order: this.orden //Retirar, ignorado en backen para devolver mas rapido/
            })
            .then(response => {
                this.creditnotesticket = response.data.data;
                this.paginaActual = response.data.current_page; // Página actual
                this.haySiguientePagina = !!response.data.next_page_url;// Si existe una siguiente página
                if (this.haySiguientePagina) {
                    this.paginaMaxima = Math.max(this.paginaMaxima, this.paginaActual + 1);
                }
                if (response.data.data.length < this.limite) {
                    this.total = (this.paginaActual - 1) * this.limite + response.data.data.length;
                }else{
                    this.total = response.data.total;
                }
                console.log(this.total)
                this.setCreditNotesTicket();
                this.desde = response.data.from;
                this.hasta = response.data.to;
                this.cargando = false;
                this.creditnotesticket.forEach(function(element){
                    element.loading = false
                })
            })
            .catch(error => {
                console.log("Error traer data") // Aqui controlar error 500
            })
        },
        setCreditNotesTicket: function () {
            console.log(this.creditnotesticket)
            if(this.creditnotesticket.length == 0){
                return false
            }else{
                for(let i=0; i < this.creditnotesticket.length ; i++){
                    if(this.creditnotesticket[i].serie.substr(0,1) == 'B'){
                        this.creditnotes.push(this.creditnotesticket[i])
                    }
                }
                return true
            }
        },
        sendMail: function (data) {
            this.previacorreo = true,
            this.sendcorreo = true,
            axios
            .post(process.env.VUE_APP_API_URL + 'notacredito/mail', {
                token: this.$store.getters.userToken,
                id: data.idNotaCredito,
                mail: this.recipients
            })
            .then(response => (
               this.sendcorreo = false,
               this.previacorreo = false,
               this.$snotify.success(response.data.message, 'Exito')
                ))
             .catch(error => (
                this.previacorreo = false,
                this.previacorreo = false,
                this.$snotify.error(error.response.data.response, 'Error')
            ))
        },
        viewPdf: function (data) {
            this.pdfobject = ''
            this.cargandopdf2 = true
            axios
           .post(process.env.VUE_APP_API_URL + 'notacredito/pdf',{
               token: this.$store.getters.userToken,
            //id: data.serie + data.numero
                id: data.idNotaCredito
           }, config)
           .then(response => (
               this.pdfobject = response.data.base64,
               this.cargandopdf2 = false
           ))
           .catch(function (error){

           })
        },
        downloadPdf: function (data){
            let tag = document.createElement('i')
            tag.classList.add('fa','fa-spin', 'fa-spinner')
            let name = data.serie + '-' + data.numero + '.pdf'
            let file = 'data:application/pdf;base64,'+ data.pdf
            this.cargandopdf = true
            this.$swal({
                title: 'Procesando Descarga',
                content: tag,
                icon: 'info',
                buttons: false,
                dangerMode: false
            })
           axios
           .post(process.env.VUE_APP_API_URL + 'notacredito/pdf',{
               token: this.$store.getters.userToken,
               id: data.idNotaCredito
           })
           .then(response => (
               file = 'data:application/pdf;base64,'+ response.data.base64,
               this.cargandopdf = false,
               download(file, name,'application/pdf'),
               this.$swal.close()
           ))
            .catch(error => (
                this.$swal.close(),
                this.$snotify.error(error.response.data.response, 'Error'),
                this.cargandopdf = false
            ))
        },
        downloadCdr: function (data){
            let tag = document.createElement('i')
            tag.classList.add('fa','fa-spin', 'fa-spinner')
            let name = 'CDR-' + data.serie + '-' + data.numero + '.zip'
            let file = 'data:application/pdf;base64,'+ data.pdf
            this.cargandocdr = true
            this.$swal({
                title: 'Procesando Descarga',
                content: tag,
                icon: 'info',
                buttons: false,
                dangerMode: false
            })
           axios
           .post(process.env.VUE_APP_API_URL + 'notacredito/constancia',{
               token: this.$store.getters.userToken,
               id: data.idNotaCredito
           })
           .then(response => (
               file = 'data:application/zip;base64,'+ response.data.msg.xml,
               this.cargandocdr = false,
               download(file, name,'application/zip'),
               this.$swal.close()
           ))
           .catch(function (error){

           })
        },
        downloadXml: function (data){
            let xml = ''
            let file = ''
            let name = data.serie + '-' + data.numero + '.zip'
            let tag = document.createElement('i')
            this.cargandopdf = true
            tag.classList.add('fa','fa-spin', 'fa-spinner')
            this.$swal({
            title: 'Obteniendo XML',
            content: tag,
            icon: 'info',
            buttons: false,
            dangerMode: false
            })
            axios
            .post(process.env.VUE_APP_API_URL + 'notacredito/xml', {
                token: this.$store.getters.userToken,
                id: data.idNotaCredito
            })
            .then(response => (
                xml = response.data.response.xml,
                file = 'data:application/zip;base64,'+ xml,
                this.downloadxml(file, name, xml),
                this.$swal.close()
            ))
            .catch(error => (
                this.$snotify.error('Error al descargar el archivo', 'Error')
            ))
        },
        downloadxml: function (file, name, xml) {
            if(xml != null){
                download(file, name,'application/zip')
            }else{
                this.$snotify.error('El documento aun no tiene constancia porque aun esta en proceso!', 'Error')
            }
        },
        estadoEmision: function (value) {
            this.spinoff = true
            axios
            .post(process.env.VUE_APP_API_URL + 'documento/motivorechazo', {
                token: this.$store.getters.userToken,
                serie: value.serie,
                numero: value.numero,
                tipo: '03'
            })
            .then(response => ( 
                this.descripcionRechazo = response.data.msg.descripcion,
                this.spinoff = false
            ))
            .catch(error => (
                this.$snotify.error(error.response.data, 'Error'),
                this.motivoRechazo = false,
                this.spinoff = false
            )) 
        }
    }
}
</script>

<style>
    .espacio {
        margin-left: 15px;
    }
    .input-requerido {
        color:red;
        opacity: 0.7;
    }
</style>

